import React from "react";
import PageHero from "../components/PageHero";
import Careers from "../components/Careers";
import Industries from "../components/Industries";
import Testimonials from "../components/Testimonials";
import { IMAGES } from "../config/siteConfig";

export default function JobSeekers() {
  return (
    <>
      <PageHero
        label="Job Seekers"
        title="Your next opportunity could be"
        highlight="closer than you think."
        subtitle="Whether it's your first career step or your next leadership move, we connect professionals with organizations where they can grow."
        image={IMAGES.jobseekers}
      />
      <Careers />
      <Industries />
      <Testimonials />
    </>
  );
}
